var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.71875 2.625 0 6 0H21V12C21 13.6875 22.3125 15 24 15H36V28.5H16.5C13.125 28.5 10.5 31.2188 10.5 34.5V48H6C2.625 48 0 45.375 0 42V6ZM36 12H24V0L36 12ZM16.5 33H19.5C22.3125 33 24.75 35.4375 24.75 38.25C24.75 41.1562 22.3125 43.5 19.5 43.5H18V46.5C18 47.3438 17.25 48 16.5 48C15.6562 48 15 47.3438 15 46.5V42V34.5C15 33.75 15.6562 33 16.5 33ZM19.5 40.5C20.7188 40.5 21.75 39.5625 21.75 38.25C21.75 37.0312 20.7188 36 19.5 36H18V40.5H19.5ZM28.5 33H31.5C33.9375 33 36 35.0625 36 37.5V43.5C36 46.0312 33.9375 48 31.5 48H28.5C27.6562 48 27 47.3438 27 46.5V34.5C27 33.75 27.6562 33 28.5 33ZM31.5 45C32.25 45 33 44.3438 33 43.5V37.5C33 36.75 32.25 36 31.5 36H30V45H31.5ZM39 34.5C39 33.75 39.6562 33 40.5 33H45C45.75 33 46.5 33.75 46.5 34.5C46.5 35.3438 45.75 36 45 36H42V39H45C45.75 39 46.5 39.75 46.5 40.5C46.5 41.3438 45.75 42 45 42H42V46.5C42 47.3438 41.25 48 40.5 48C39.6562 48 39 47.3438 39 46.5V40.5V34.5Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.104582ce2463fd888a5eb4a61817c888.svg";
export { ForwardRef as ReactComponent };